import { ref } from 'vue';
import { validateRoomId } from '@/shared/api/room';

export const useCheckRoom = ({ isLoading, link }) => {
  const error = ref('');

  const checkRoom = async () => {
    if (!link.value) {
      error.value = 'errors.necessaryField';
      isLoading.value = false;
      return false;
    }

    const room = link.value.toLowerCase();
    const roomNameResult = room.startsWith('http') ? room.split('/room/').at(-1) : room;

    if (!/^[a-z0-9-_]+$/.test(roomNameResult) || roomNameResult.length < 4 || roomNameResult.length > 40) {
      error.value = 'studentPage.wrongFormat';
      isLoading.value = false;
      return false;
    }

    try {
      isLoading.value = true;
      await validateRoomId(roomNameResult);
      error.value = '';

      return roomNameResult;
    } catch (e) {
      error.value = 'deepLink.linkNotFound';

      return false;
    } finally {
      isLoading.value = false;
    }
  };

  return { error, checkRoom };
};
